import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';

// ---- F8 employee asset requisition ----
export type AssetRequisitionStatus = 'DRAFT' | 'PENDING' | 'APPROVED' | 'REJECTED' | 'FULFILLED' | 'CANCELLED';

export interface AssetRequisition {
  id: string; requisitionNo: string; requestedByUserId: string; requesterName?: string | null;
  departmentId?: string | null; departmentName?: string | null; fixedAssetCategoryId?: string | null; categoryName?: string | null;
  description: string; justification?: string | null; neededBy?: string | null; status: AssetRequisitionStatus;
  approvalRequestId?: string | null; fulfilledAssetId?: string | null; fulfilledAssetCode?: string | null;
  fulfilledTransferId?: string | null; purchaseOrderId?: string | null; purchaseOrderNo?: string | null;
  cancelReason?: string | null; createdAt?: string;
}
export interface AssetRequisitionCreate {
  description: string; justification?: string; departmentId?: string | null; fixedAssetCategoryId?: string | null; neededBy?: string | null;
}
export interface RequisitionAttachment { id: string; fileName: string; contentType: string; sizeBytes: number; uploadedByName?: string; createdAt: string; }
/** A live asset category as the requisition form's picker shows it. */
export interface RequisitionCategory { id: string; name: string; }
/** A live department as the requisition form's picker shows it. */
export interface RequisitionDepartment { id: string; name: string; }
interface Page<T> { content: T[]; totalElements: number; }

const E = ENDPOINTS.ASSET_REQUISITION;

export const AssetRequisitionService = {
  mine: async (i: string, page = 0, size = 50): Promise<Page<AssetRequisition>> => (await axios.get(E.MINE(i), { params: { page, size } })).data,
  all: async (i: string, status?: string, page = 0, size = 50): Promise<Page<AssetRequisition>> =>
    (await axios.get(E.LIST(i), { params: status ? { status, page, size } : { page, size } })).data,
  categories: async (i: string): Promise<RequisitionCategory[]> => (await axios.get(E.CATEGORIES(i))).data,
  departments: async (i: string): Promise<RequisitionDepartment[]> => (await axios.get(E.DEPARTMENTS(i))).data,
  get: async (i: string, id: string): Promise<AssetRequisition> => (await axios.get(E.ONE(i, id))).data,
  create: async (i: string, req: AssetRequisitionCreate): Promise<AssetRequisition> => (await axios.post(E.LIST(i), req)).data,
  submit: async (i: string, id: string): Promise<AssetRequisition> => (await axios.post(E.SUBMIT(i, id))).data,
  cancel: async (i: string, id: string, reason: string): Promise<AssetRequisition> => (await axios.post(E.CANCEL(i, id), { reason })).data,
  fulfil: async (i: string, id: string, body: { assetId: string; transferDate?: string; reason?: string }): Promise<AssetRequisition> =>
    (await axios.post(E.FULFIL(i, id), body)).data,
  linkPo: async (i: string, id: string, purchaseOrderId: string): Promise<AssetRequisition> =>
    (await axios.post(E.LINK_PO(i, id), { purchaseOrderId })).data,
  attachments: async (i: string, id: string): Promise<RequisitionAttachment[]> => (await axios.get(E.ATTACHMENTS(i, id))).data,
  attach: async (i: string, id: string, file: File): Promise<RequisitionAttachment> => {
    const form = new FormData();
    form.append('file', file);
    return (await axios.post(E.ATTACHMENTS(i, id), form)).data;
  },
  download: async (i: string, id: string, attachmentId: string): Promise<Blob> =>
    (await axios.get(E.ATTACHMENT(i, id, attachmentId), { responseType: 'blob' })).data,
};
// ---- end F8 ----
